let code = 'pimgestao';
let codeAPI = 'pim';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};